
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/layout/Header/HeaderSearch/index.less?modules";
export default {"input": `input-xPB03YpN`,"show": `show-x0hR7cJy`,"headerSearch": `headerSearch-Ivy8fwf6`}
